'use strict';

exports.__esModule = true;
exports.capitalize = exports.renameKeys = undefined;

var _ramda = require('ramda');

var renameKeys = exports.renameKeys = (0, _ramda.curry)(function (keysMap, obj) {
  return (0, _ramda.reduce)(function (acc, key) {
    return (0, _ramda.assoc)(keysMap[key] || key, obj[key], acc);
  }, {}, (0, _ramda.keys)(obj));
});
var capitalize = exports.capitalize = (0, _ramda.compose)((0, _ramda.join)(''), (0, _ramda.juxt)([(0, _ramda.compose)(_ramda.toUpper, _ramda.head), _ramda.tail]));